
export type GetTweetFeed200TweetsItemTags = {
  hashtagIds?: string[];
};
